import ztComponent from './ztTab.vue'
import ztComponentChild from './ztTabItem.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
  Vue.component(ztComponentChild.name, ztComponentChild)
}
